$(document).ready(function() {
	if(!document.querySelector('.GPC0051')) return false;
	
	var $obj = $('.GPC0051');
	$obj.each(function() {
		var $slick = $(this).find('.items-group .items').slick({
			infinite: false,
			listStyle: true, // WA-GPC0051-03
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows : true,
			dots: true,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : false
				}
			}],
			prevArrow: carouselOptions.bigAnglePrev, // common.js variable
			nextArrow: carouselOptions.bigAngleNext // common.js variable
		});
	});

	var waNumber = 0;
	$obj.find('.items .item').each(function() {
		var $target;
		if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
			$target = $(this).find('.title');
		}
		if($target) {
			$target.attr('id', 'waGPC0050_'+waNumber);
			$(this).find('a.btn').attr('aria-describedby', 'waGPC0050_'+waNumber);
			$(this).find('a.link-text').attr('aria-describedby', 'waGPC0050_'+waNumber);
			waNumber++;
		}
	});
});